import {
  Alert,
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Typography,
  Divider,
} from "@mui/material";
import { useState } from "react";
import {
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";

export function ResumenCard({
  totalEfectivo,
  totalInstrumentos,
  totalTarjetas,
  totalRetenciones,
  totalRedondeo,
  totalGeneral,
  totalesCoinciden,
  diferencia,
  totalEsperado,
  instrumentos,
  tarjetas,
  formatCurrency,
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card
      sx={{
        bgcolor: totalesCoinciden ? "success.50" : "warning.50",
        border: 2,
        borderColor: totalesCoinciden ? "success.main" : "warning.main",
        transition: "all 0.3s ease",
      }}
    >
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        {/* HEADER CON BOTÓN EXPANDIR */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            color={totalesCoinciden ? "success.main" : "warning.main"}
          >
            RESUMEN
          </Typography>
          <IconButton size="small" onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        {/* DESGLOSE COLAPSABLE - HORIZONTAL */}
        <Collapse in={expanded}>
          <Box sx={{ display: "flex", gap: 2, mb: 1.5, flexWrap: "wrap" }}>
            <Box sx={{ minWidth: 140 }}>
              <Typography variant="caption" color="text.secondary">
                Efectivo
              </Typography>
              <Typography variant="body2" fontWeight="600">
                {formatCurrency(totalEfectivo)}
              </Typography>
            </Box>

            <Divider orientation="vertical" flexItem />

            <Box sx={{ minWidth: 140 }}>
              <Typography variant="caption" color="text.secondary">
                Inst. Bancarios ({instrumentos.length})
              </Typography>
              <Typography variant="body2" fontWeight="600">
                {formatCurrency(totalInstrumentos)}
              </Typography>
            </Box>

            <Divider orientation="vertical" flexItem />

            <Box sx={{ minWidth: 140 }}>
              <Typography variant="caption" color="text.secondary">
                Tarjetas ({tarjetas.length})
              </Typography>
              <Typography variant="body2" fontWeight="600">
                {formatCurrency(totalTarjetas)}
              </Typography>
            </Box>

            <Divider orientation="vertical" flexItem />

            <Box sx={{ minWidth: 140 }}>
              <Typography variant="caption" color="text.secondary">
                Retenciones
              </Typography>
              <Typography variant="body2" fontWeight="600">
                {formatCurrency(totalRetenciones)}
              </Typography>
            </Box>
          </Box>
          <Divider sx={{ mb: 1 }} />
        </Collapse>

        {/* TOTALES - SIEMPRE VISIBLES */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Total esperado:
          </Typography>
          <Typography variant="subtitle1" fontWeight="600">
            {formatCurrency(totalEsperado)}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold">
            TOTAL CALCULADO:
          </Typography>
          <Box display="flex" alignItems="center" gap={0.5}>
            {totalesCoinciden && totalGeneral > 0 ? (
              <CheckCircleIcon color="success" fontSize="small" />
            ) : totalGeneral > 0 ? (
              <WarningIcon color="warning" fontSize="small" />
            ) : null}
            <Typography
              variant="h6"
              fontWeight="bold"
              color={
                totalesCoinciden
                  ? "success.main"
                  : totalGeneral > 0
                    ? "warning.main"
                    : "text.primary"
              }
            >
              {formatCurrency(totalGeneral)}
            </Typography>
          </Box>
        </Box>

        {/* ALERTAS */}
        {!totalesCoinciden && totalGeneral > 0 && totalEsperado > 0 && (
          <Alert severity="warning" sx={{ mt: 1, py: 0 }}>
            <Typography variant="caption">
              Diferencia: {formatCurrency(Math.abs(diferencia))}
              {diferencia > 0 ? " (de más)" : " (de menos)"}
            </Typography>
          </Alert>
        )}

        {totalesCoinciden && totalGeneral > 0 && totalRedondeo > 0 && (
          <Alert severity="warning" sx={{ mt: 1, py: 0 }}>
            <Typography variant="caption">
              Se generara un ajuste de credito por:{" "}
              {formatCurrency(Math.abs(totalRedondeo))}
            </Typography>
          </Alert>
        )}

        {totalesCoinciden && totalGeneral > 0 && (
          <Alert severity="success" sx={{ mt: 1, py: 0 }}>
            <Typography variant="caption" fontWeight="600">
              ✓ Los totales coinciden
            </Typography>
          </Alert>
        )}
      </CardContent>
    </Card>
  );
}
